import React from "react";
import Select from "react-select";
import { onlyNumericInput } from "@/utils";
import { useGetAgentePartnerListQuery, useGetSalesPartnerListQuery } from "@/redux/partnerApi";

export const OtherInfo = ({ formData, handleChange, setFormData, disabled }) => {
    const { agentePartner, salesPartner, contractMechanic } = formData;
    const { data: agentPartnerData, agentRefetch } = useGetAgentePartnerListQuery();
    const { data: salesPartnerData, salesRefetch } = useGetSalesPartnerListQuery();

    const agentPartnerOptions =
        agentPartnerData && agentPartnerData.data
            ? agentPartnerData.data.map((item) => ({
                  value: item.id,
                  label: item.name,
              }))
            : [];

    const salesPartnerOptions =
        salesPartnerData && salesPartnerData.data
            ? salesPartnerData.data.map((item) => ({
                  value: item.id,
                  label: item.name,
              }))
            : [];

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>소개처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={agentPartnerOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="소개처 선택"
                            value={agentPartnerOptions.find((opt) => opt.label === agentePartner)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    agentePartner: option.label,
                                }));
                            }}
                            isDisabled={disabled}
                        />
                    </div>
                    {/* <div className="form-element_button">
                        <button
                            type="button"
                            className="btn-form_element btn-outline"
                            onClick={() => {
                                setFormData((prevState) => ({
                                    ...prevState,
                                    agentPartnersPopupStatus: true,
                                }));
                            }}
                        >
                            선택
                        </button>
                    </div> */}
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>영업처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={salesPartnerOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="영업자 선택"
                            value={salesPartnerOptions.find((opt) => opt.label === salesPartner)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    salesPartner: option.label,
                                }));
                            }}
                            isDisabled={disabled}
                        />
                    </div>
                    {/* <div className="form-element_button">
                        <button
                            type="button"
                            className="btn-form_element btn-outline"
                            onClick={() => {
                                setFormData((prevState) => ({
                                    ...prevState,
                                    salesPartnersPopupStatus: true,
                                }));
                            }}
                        >
                            선택
                        </button>
                    </div> */}
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            {/* 공업사 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>공업사(공장)</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractMechanic.mechanicCorpName"
                            value={contractMechanic?.mechanicCorpName || ""}
                            placeholder=""
                            onChange={handleChange}
                            disabled={disabled}
                        />
                        {/* <Select
                            options={insuranceCorpOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="공업사 선택"
                            value={insuranceCorpOptions.find((opt) => opt.value === contractMechanic?.mechanicCorpName)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    contractMechanic: {
                                        ...prev.contractMechanic,
                                        mechanicCorpName: option.value,
                                    },
                                }));
                            }}
                        /> */}
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>공업사(공장) 연락처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractMechanic.phone"
                            value={contractMechanic?.phone || ""}
                            placeholder=""
                            onChange={handleChange}
                            onInput={onlyNumericInput}
                            maxLength={11}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
        </>
    );
};
